class DuckSelector {
    constructor(func) {
        this.func = func;
    }

    injectSelectors(selectors) {
        return this.func(selectors);
    }
}

export { DuckSelector as default };
